import React from 'react';
import { IAddRowAction } from '../AddRowActions';
import { TotalCosts } from '../Items/TotalCosts';
import Section from '../Section';
import { OtherCostsStyled } from './OtherCosts.styles';
import { IGroupTotals } from '../../../ui-toolkit/cdItems/interfaces/IGroupTotals';
import { ITotals } from '../../../ui-toolkit/cdItems/interfaces/ITotals';

export interface IOtherCosts {
  initialEscrowActions: IAddRowAction[];
  initialEscrowContent?: React.ReactNode;
  initialEscrowTotals?: ITotals | null;
  otherActions: IAddRowAction[];
  otherContent?: React.ReactNode;
  otherTotals?: ITotals | null;
  prepaidsActions: IAddRowAction[];
  prepaidsContent?: React.ReactNode;
  prepaidsTotals?: ITotals | null;
  showSeller: boolean;
  taxesActions: IAddRowAction[];
  taxesContent?: React.ReactNode;
  taxesTotals?: ITotals | null;
  totalOtherCosts: IGroupTotals;
  hasEditPermissions?: boolean;
}

export default class OtherCosts extends React.Component<IOtherCosts> {
  public render() {
    const {
      initialEscrowActions,
      initialEscrowContent,
      initialEscrowTotals,
      otherActions,
      otherContent,
      otherTotals,
      prepaidsActions,
      prepaidsContent,
      prepaidsTotals,
      showSeller,
      taxesActions,
      taxesContent,
      taxesTotals,
      totalOtherCosts,
      hasEditPermissions,
    } = this.props;
    const { subtotals } = totalOtherCosts;
    return (
      <OtherCostsStyled title="Other Costs">
        <Section
          data-test-id="taxes-and-other-gov-fees"
          name="E. Taxes and other gov fees"
          showSeller={showSeller}
          addRowActions={taxesActions}
          totals={taxesTotals}
          hasEditPermissions={hasEditPermissions}
        >
          {taxesContent}
        </Section>
        <Section
          data-test-id={`prepaids`}
          name="F. Prepaids"
          showSeller={showSeller}
          addRowActions={prepaidsActions}
          totals={prepaidsTotals}
          hasEditPermissions={hasEditPermissions}
        >
          {prepaidsContent}
        </Section>
        <Section
          data-test-id={`initial-escrow-at-closing`}
          name="G. Initial escrow payment at closing"
          showSeller={showSeller}
          addRowActions={initialEscrowActions}
          totals={initialEscrowTotals}
          hasEditPermissions={hasEditPermissions}
        >
          {initialEscrowContent}
        </Section>
        <Section
          data-test-id={`other`}
          name="H. Other"
          showSeller={showSeller}
          addRowActions={otherActions}
          totals={otherTotals}
          hasEditPermissions={hasEditPermissions}
        >
          {otherContent}
        </Section>
        <Section
          name={`I. Total other costs (${showSeller ? 'Buyer' : 'Borrower'}-paid)`}
          totals={subtotals}
          showSeller={showSeller}
          showLenderPaid={false}
          showNettedOut={false}
        >
          <TotalCosts
            showSeller={showSeller}
            text="Other costs subtotals (E+F+G+H)"
            buyerClosingTotal={subtotals.buyer_at_closing}
            buyerBeforeTotal={subtotals.buyer_before_closing}
            sellerClosingTotal={subtotals.seller_at_closing}
            sellerBeforeTotal={subtotals.seller_before_closing}
            othersTotal={subtotals.paid_by_others}
          />
        </Section>
      </OtherCostsStyled>
    );
  }
}
